import { ScrollReveal } from '@/components/effects/ScrollReveal';
import { GraduationCap, ShieldCheck, Rocket, TrendingUp, ArrowRight } from 'lucide-react';

const SERVICES = [
  {
    key: 'learn',
    eyebrow: 'Acodia Learn',
    title: 'I want to build tech skills or change my career',
    body: 'Expert-led training in Cybersecurity, AI, Machine Learning, and Data Analytics. Face to face or online. One to one or small group.',
    icon: GraduationCap,
    colorVar: '--track-aiml-fg',
    tintVar: '--track-aiml-bg',
  },
  {
    key: 'defend',
    eyebrow: 'Acodia Defend',
    title: 'I want to protect my business from cyber threats',
    body: 'Acodia Watch monitoring, vulnerability assessments, cloud security, and compliance support — without enterprise pricing.',
    icon: ShieldCheck,
    colorVar: '--track-cyber-fg',
    tintVar: '--track-cyber-bg',
  },
  {
    key: 'launch',
    eyebrow: 'Acodia Launch',
    title: 'I want to get a job offer in tech',
    body: 'Profile rebuild, interview preparation, active placement support. Most of our clients receive their first offer within 90 days.',
    icon: Rocket,
    colorVar: '--track-career-fg',
    tintVar: '--track-career-bg',
  },
  {
    key: 'reach',
    eyebrow: 'Acodia Reach',
    title: 'I want to grow my business online',
    body: 'SEO, paid media, email, and content that converts. Build the digital presence your business deserves.',
    icon: TrendingUp,
    colorVar: '--track-data-fg',
    tintVar: '--track-data-bg',
  },
];

export default function PricingLanding({ onSelect }) {
  return (
    <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-16" data-testid="pricing-landing">
      <div className="text-center max-w-3xl mx-auto mb-12">
        <ScrollReveal>
          <h1
            className="font-display font-extrabold tracking-[-0.03em] mb-4"
            style={{ fontSize: 'clamp(2rem, 4.5vw, 3.5rem)', color: 'var(--white)' }}
          >
            Find the Right Acodia Service for You.
          </h1>
          <p className="font-body font-light text-base" style={{ color: 'var(--tm)', lineHeight: '1.72' }}>
            Answer a few questions and we will show you exactly what we recommend and what it costs.
            No obligation. No sales pitch. Just a straight answer.
          </p>
        </ScrollReveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {SERVICES.map(({ key, eyebrow, title, body, icon: Icon, colorVar, tintVar }, i) => (
          <ScrollReveal key={key} delay={i * 0.05}>
            <button
              type="button"
              data-testid={`pricing-landing-${key}`}
              onClick={() => onSelect(key)}
              className="w-full text-left p-6 sm:p-8 rounded-lg transition-all group"
              style={{
                background: `var(${tintVar})`,
                border: `1px solid var(${colorVar})`,
                minHeight: 200,
              }}
            >
              <div className="flex items-start justify-between mb-4">
                <div
                  className="flex items-center justify-center rounded"
                  style={{
                    width: 40,
                    height: 40,
                    background: `var(${tintVar})`,
                    border: `1px solid var(${colorVar})`,
                    color: `var(${colorVar})`,
                  }}
                >
                  <Icon size={18} />
                </div>
                <ArrowRight
                  size={18}
                  className="transition-transform duration-200 group-hover:translate-x-1"
                  style={{ color: `var(${colorVar})` }}
                />
              </div>
              <p
                className="font-mono text-[10px] uppercase tracking-[0.22em] mb-1"
                style={{ color: `var(${colorVar})` }}
              >
                {eyebrow}
              </p>
              <h2 className="font-display text-lg sm:text-xl font-semibold mb-2" style={{ color: 'var(--white)' }}>
                {title}
              </h2>
              <p className="font-body text-sm" style={{ color: 'var(--tm)', lineHeight: '1.65' }}>
                {body}
              </p>
            </button>
          </ScrollReveal>
        ))}
      </div>
    </div>
  );
}
